var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOctagon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "26px",
    viewBox: "0 0 25 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "octagon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visitor-Enter-zone-manually---Wrong-parking-zone",
    transform: "translate(-50.000000, -457.000000)",
    fill: "#CC0605",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(25.000000, 271.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0155868,211.124993 C41.6340752,211.124993 42.187459,210.897128 42.6757391,210.4414 L42.6757391,210.4414 L49.3163483,203.751963 C49.7720761,203.296235 49.9999404,202.742851 49.9999404,202.091811 L49.9999404,202.091811 L49.9999404,195.109406 C49.9999404,194.490917 49.7720761,193.953809 49.3163483,193.498081 L49.3163483,193.498081 L49.3163483,193.449253 L42.6757391,186.808644 C42.187459,186.352916 41.6340752,186.125052 41.0155868,186.125052 L41.0155868,186.125052 L34.0331816,186.125052 C33.3821417,186.125052 32.8287571,186.352916 32.3730293,186.808644 L32.3730293,186.808644 L25.6835921,193.449253 C25.2278643,193.937534 25,194.490917 25,195.109406 L25,195.109406 L25,202.091811 C25,202.742851 25.2278643,203.296235 25.6835921,203.751963 L25.6835921,203.751963 L32.3730293,210.4414 C32.8287571,210.897128 33.3658652,211.124993 33.9843536,211.124993 L33.9843536,211.124993 L41.0155868,211.124993 Z M41.0155868,208.781248 L34.0331816,208.781248 L27.3437444,202.091811 L27.3437444,195.109406 L34.0331816,188.468797 L41.0155868,188.468797 L47.656196,195.109406 L47.656196,202.091811 L41.0155868,208.781248 Z",
    id: "octagon"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagon);
export default __webpack_public_path__ + "static/media/octagon.98390a3445f29c3258c5440b04a13b3b.svg";
export { ForwardRef as ReactComponent };